// Vuex records module actions
import { API } from "@/config";

import {
  FILL_DETAILS,
  FILL_STATUS_LIST,
  FILL_CURRENT_CALL_DETAILS,
  FILL_SURVEY_INPUTS_LIST,
  FILL_SURVEY_LIST,
  FILL_CURRENT_CALL_SURVEY,
  FILL_SURVEY_QUESTIONS,
  FILL_LIST,
  FILL_SURVEY_RESULTS_LIST,
  FILL_SURVEY_ANSWERS,
  CLEAR_SURVEY_ANSWERS
} from "./mutations-types";

export default {
  async getListByProject({ state, commit }, project) {
    try {
      const params = {
        project
      };
      const { records, total } = (await API.get("campaign/getListByProject", { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (e) {
      console.log(e);
    }
  },
  async getDetails({ commit }, campaignUuid) {
    try {
      const params = {
        campaign_uuid: campaignUuid
      };
      const response = (await API.get("campaigns/getDetails", { params })).data.data;
      commit(FILL_DETAILS, response);
    } catch (err) {
      console.log(err);
    }
  },
  async getAllStatusAndRecordDictionary({ commit }, data) {
    try {
      const params = {
        project_uuid: data.projectUuid,
        dialout_uuid: data.dialoutUuid
      };
      const response = (await API.get("campaigns/getAllStatusAndRecordDictionary", { params })).data.data;
      commit(FILL_STATUS_LIST, response);
    } catch (err) {
      console.log(err);
    }
  },
  async cloneRecord(context, params) {
    try {
      const response = await API.put("campaigns/cloneRecord", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
    }
  },
  async removeRecord(context, params) {
    try {
      const response = await API.patch("campaigns/removeRecord", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
    }
  },
  async getCurrentCallDetails({ commit }, agentUuid) {
    try {
      const params = {
        agent_uuid: agentUuid
      };
      const response = (await API.get("campaigns/getCurrentCallDetails", { params })).data.data;
      commit(FILL_CURRENT_CALL_DETAILS, response);
    } catch (err) {
      console.log(err);
    }
  },
  async startCampaign(context, data) {
    try {
      const params = { ...data };
      const response = await API.get("campaigns/startCampaign", { params });
      return response.data.code;
    } catch (err) {
      console.log(err);
    }
  },
  async addRecordToList(context, params) {
    try {
      const response = await API.put("/campaigns/addRecordToList", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async addMultipleRecordsToList(context, params) {
    try {
      const response = await API.put("/campaigns/addMultipleRecordsToList", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async createCampaignType(context, params) {
    try {
      const response = await API.put("/campaigns/createCampaignType", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async editCampaignType(context, params) {
    try {
      const response = await API.patch("/campaigns/editCampaignType", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },

  // TODO: przeniesc funkcje powiazane z ankietami do osbnego store

  async getSurveyInputTypesList({ commit }) {
    try {
      const response = (await API.get("campaigns/getSurveyInputTypesList")).data.data;
      commit(FILL_SURVEY_INPUTS_LIST, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async createNewSurvey(context, params) {
    try {
      const response = await API.put("campaigns/createNewSurvey", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async editSurvey(context, params) {
    try {
      const response = await API.put("campaigns/editSurvey", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSurveysList({ commit }, projectUuid) {
    try {
      const params = {
        project_uuid: projectUuid
      };
      const response = (await API.get("campaigns/getSurveysList", { params })).data.data;
      commit(FILL_SURVEY_LIST, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSurveyResultsList({ commit }) {
    try {
      const response = (await API.get("campaigns/getSurveyResultsList")).data.data;
      commit(FILL_SURVEY_RESULTS_LIST, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSurveyQuestions({ commit }, surveyUuid) {
    try {
      const params = {
        survey_uuid: surveyUuid
      };
      const response = (await API.get("campaigns/getSurveyQuestions", { params })).data.data;
      commit(FILL_SURVEY_QUESTIONS, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSurveyAnswers({commit}, params){
    try {
      const response = (await API.get('campaigns/getSurveyAnswers', {params})).data.data;
      commit(FILL_SURVEY_ANSWERS, response)
    } catch(err){
      console.log(err);
      return false;
    }
  },
  clearSurveyAnswers({commit}){
    commit(CLEAR_SURVEY_ANSWERS);
  },
  async getSurveyForCurrentCall({ commit }, wh1Uuid) {
    try {
      const params = {
        wh1_uuid: wh1Uuid
      };
      const response = (await API.get("campaigns/getSurveyForCurrentCall", { params })).data.data;
      commit(FILL_CURRENT_CALL_SURVEY, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSurveyQuestionsForConnections({ commit }, wh1Uuid) {
    try {
      const params = {
        wh1_uuid: wh1Uuid
      };
      const response = (await API.get("campaigns/getSurveyQuestionsForConnections", { params }))
        .data.data;
      commit(FILL_CURRENT_CALL_SURVEY, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async getSurveyResult({ commit }, data) {
    try {
      const params = {
        wh1_uuid: data.wh1Uuid,
        survey_uuid: data.surveyUuid
      };
      const response = (await API.get("campaigns/getSurveyResult", { params })).data.data;
      commit(FILL_CURRENT_CALL_SURVEY, response);
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async submitSurvey(context, params) {
    try {
      const response = await API.put("campaigns/submitSurvey", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  async editNoteForCall(context, params) {
    try {
      const response = await API.patch("campaigns/editNoteForCall", params);
      return response.data.code;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
};
